/* eslint-disable @typescript-eslint/no-unused-vars */
import axios, { AxiosError } from "axios";
import { ResponseDTO } from "../../interfaces/response";

const generateheaderOptions = (tipoToken = 'default') => {
    const token = tipoToken === 'file' ? localStorage.getItem('tokenFile') : localStorage.getItem('token');
    return {
        'Authorization': `Bearer ${token}`,
    };
};

const errorResponse = (error: any) => {
    let { message, statusCode } = (error?.code != null) ? error?.response?.data : error;

    if (statusCode >= 400) {
        message = error?.response?.data?.reasons.map((reason: any) => reason.message).join(", ");
    }

    return { statusCode, message };
};


const headersFile: any = {
    'Authorization': `Bearer ${localStorage.getItem('token')}`,
    responseType: 'blob'
};

export default class HttpService {
    async get(baseURL: string, endpoint?: string, params?: { [key: string]: any }): Promise<ResponseDTO | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: generateheaderOptions()};
            return axios.get(url, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async getFile(baseURL: string, endpoint?: string, params?: { [key: string]: any }): Promise<ResponseDTO | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: headersFile };
            return axios.get(url, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async post(baseURL: string, endpoint?: string, body?: any, params?: { [key: string]: any }, asFormEncoded?: boolean): Promise<any | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: generateheaderOptions() };

            if (asFormEncoded && body) {
                const bodyParams = new URLSearchParams();
                for (const b of Object.keys(body)) {
                    bodyParams.append(b, body[b]);
                }
                body = bodyParams;
            }

            return await axios.post(url, body, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async postToken(accessToken: string, baseURL: string, endpoint?: string, body?: any, params?: { [key: string]: any }, asFormEncoded?: boolean): Promise<any | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers : {
                'Authorization': `Bearer ${accessToken}`
            }};

            if (asFormEncoded && body) {
                const bodyParams = new URLSearchParams();
                for (const b of Object.keys(body)) {
                    bodyParams.append(b, body[b]);
                }
                body = bodyParams;
            }

            return await axios.post(url, body, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async postFile(baseURL: string, endpoint?: string, body?: any, params?: { [key: string]: any }, asFormEncoded?: boolean): Promise<any | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: headersFile };
            if (asFormEncoded && body) {
                const bodyParams = new URLSearchParams();
                for (const b of Object.keys(body)) {
                    bodyParams.append(b, body[b]);
                }
                body = bodyParams;
            }

            return await axios.post(url, body, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async patch(baseURL: string, endpoint?: string, body?: any, params?: { [key: string]: any }): Promise<any | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: generateheaderOptions() };
            return axios.patch(url, body, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }

    async delete(baseURL: string, endpoint?: string, params?: { [key: string]: any }): Promise<any | any> {
        try {
            const url = endpoint ? baseURL.concat(endpoint) : baseURL;
            const options = { params, headers: generateheaderOptions() };
            return axios.delete(url, options);
        } catch (err: any | AxiosError) {
            return errorResponse(err)
        }
    }
}